import { DafetiteFooter } from '../hooks/dafetiteFooter/dafetiteFooter'

function Footer() {
	return (
		<footer className="text-center small mayor-footer mx-1">
			<DafetiteFooter />
		</footer>
	)
}
export { Footer }